import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@vimaana/ui";
import type { KundeLage } from "../lib/kundeLage";

/**
 * Lage aller Kunden in einem Abruf (`GET /kontor/kunden/lage`). Eine Minute frisch:
 * sie ändert sich mit jeder Aufgabe und Mail, die Stammdaten (`useKunden`) nicht.
 * Kunden ohne jede Spur fehlen in der Antwort.
 */
export function useKundenLage() {
  const q = useQuery<KundeLage[]>({
    queryKey: ["kunden", "lage"],
    queryFn: () => apiGet<KundeLage[]>("/api/kontor/kunden/lage"),
    staleTime: 60_000,
  });
  const nachId = useMemo(() => new Map((q.data ?? []).map((l) => [l.kunde_id, l])), [q.data]);
  return { ...q, nachId };
}
